
// TitleField.js

import React from 'react'
import '../../styles/text/TitleField.css';

const TitleField = ({ title, bold = false, level = 2, fontSize = null, className = '' }) => {
    const Tag = `h${level}`;
    return (
        <Tag className={`form-title-header1 ${className}`} style={{ fontWeight: bold ? 700 : 400, ...(fontSize && { fontSize }) }}>
            {title}
        </Tag>
    );
}


export default TitleField
